/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Blog_Count_ZeroInputs */

const en_blog_count_zero = /** @type {(inputs: Blog_Count_ZeroInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} articles`)
};

const lv_blog_count_zero = /** @type {(inputs: Blog_Count_ZeroInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} rakstu`)
};

/**
* | output |
* | --- |
* | "{count} articles" |
*
* @param {Blog_Count_ZeroInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const blog_count_zero = /** @type {((inputs: Blog_Count_ZeroInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Count_ZeroInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_blog_count_zero(inputs)
	return en_blog_count_zero(inputs)
});